class HeaderDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    const openDetails = this.querySelector('details[open]');
    if (!openDetails) return;
    openDetails.querySelector('summary').click();
  }

  onSummaryClick(event) {
    const summary = event.currentTarget;
    const details = summary.closest('details');
    const isOpen = details.hasAttribute('open');

    if (!isOpen) {
      document.body.classList.add('overflow-hidden');
      document.body.addEventListener('click', this.onBodyClick);
      details.setAttribute('open', '');
      // Dawn's CSS requires .menu-opening on the details element to
      // trigger visibility: visible and translateX(0) on .menu-drawer
      requestAnimationFrame(() => {
        details.classList.add('menu-opening');
      });
    } else {
      this.closeDrawer(details);
    }

    event.preventDefault();
  }

  closeDrawer(details) {
    if (!details) details = this.querySelector('details');
    if (!details) return;
    document.body.classList.remove('overflow-hidden');
    document.body.removeEventListener('click', this.onBodyClick);
    details.classList.remove('menu-opening');
    details.removeAttribute('open');
  }

  handleBodyClick(event) {
    const details = this.querySelector('details');
    if (this.contains(event.target)) return;
    if (details && details.hasAttribute('open')) {
      this.closeDrawer(details);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) {
        this.closeDrawer();
      }
    });
  }
}

customElements.define('header-drawer', HeaderDrawer);